import { render } from "./urlpopupcomcopy.vue?vue&type=template&id=4c0e3858&scoped=true"
import script from "./urlpopupcomcopy.vue?vue&type=script&lang=js"
export * from "./urlpopupcomcopy.vue?vue&type=script&lang=js"

import "./urlpopupcomcopy.vue?vue&type=style&index=0&id=4c0e3858&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0e3858"]])

export default __exports__